import { Icon } from '../ui/Icon'

/**
 * Mientras la API sirva datos sembrados, cualquiera que abra el panel tiene que
 * saber en un segundo que las cifras no son reales. Discreto pero permanente: va
 * arriba de todo, no se puede cerrar, y lo prende el servidor (`config.demoData`),
 * no una constante del front.
 *
 * Lleva icono **y** texto: el fondo ámbar solo no dice nada.
 */
export interface DemoDataBannerProps {
  visible: boolean
}

export function DemoDataBanner({ visible }: DemoDataBannerProps) {
  if (!visible) return null

  return (
    <div
      role="status"
      data-testid="demo-data-banner"
      className="flex items-center gap-2 border-b border-warning bg-warning-soft px-5 py-1.5 text-meta text-text"
    >
      <Icon name="atencion" size={13} className="text-warning-text" />
      <span>
        <b className="font-semibold">Datos de demostración</b> — las cifras son
        inventadas y no se pueden usar para decidir nada.
      </span>
    </div>
  )
}
